const cinemaTilePromiseKey = "cinemaTilePromise";

export type AddPromise = (p: Promise<void>) => void;

export default cinemaTilePromiseKey;
